import {Freighter} from "./freighter";

export class OrderDraftFreighterFilter {
  applied_at: string;
  freighter: Freighter;
}
